export default __webpack_public_path__ + "static/search-cdd1ec7472af2b70916774fb0f548f07.png";